import classNames from 'classnames';
import { IconV2 } from 'common/icon/iconV2.js';
import { messageLog } from 'utilities/helpers/logger/message-logger.js';
import { CellRenderType, ComponentTester } from './renderCell.js';

export const RenderStatusRating: ComponentTester<CellRenderType.statusRating> = ({ data, classes }) => {
  const wrapperClasses = classNames(
    'u-flex u-flexAlignItemsCenter u-flexJustifyCenter svg-fill-font-color',
    data?.status,
  );
  const textClassesCore = classNames('u-block u-text-sm u-textSemibold', data?.status, classes);

  if (data?.icon) {
    if (data?.iconOnLeft) {
      return (
        <div className={wrapperClasses}>
          <IconV2 icon={data.icon} size={32} />
          <span className={classNames(textClassesCore, 'u-span-width')}>{data.text}</span>
        </div>
      );
    }
    return (
      <div className={wrapperClasses}>
        <span className={classNames(textClassesCore, 'u-span-width-after')}>{data.text}</span>
        <IconV2 icon={data.icon} size={32} />
      </div>
    );
  }
  if (data?.text) {
    return <span className={textClassesCore}>{data.text}</span>;
  }
  messageLog.warning('No cell render props');
  return <div style={{ minWidth: '80px' }} />;
};
